// extracted by mini-css-extract-plugin
export var checkbox = "CnvbR";
export var checkboxLabel = "iQRmI";
export var inputsRow = "WlsW0";
export var loading = "wR6JO";
export var sectionCheckbox = "rjW7Q";
export var sectionInput = "l3qU2";
export var spin = "le7QX";
export var valid = "_2kQJp";